<template>
  <Chart :chartData="computedData" :options="computedOptions" />
</template>

<script>
  import ChartMetrics from '@/mixins/ChartMetrics'
  import merge from 'lodash/merge'
  import utils from '@/utils'

  const colors = [
    '#6699ff',
    '#99ccff',
    '#bbddff',
  ]

  export default {
    name: 'ChartMemory',
    mixins: [
      ChartMetrics,
    ],
    computed: {
      computedData() {
        const datasets = [{
          borderColor: colors[0],
          borderDash: [5],
          borderWidth: 2,
          data: this.data ? this.data[0]: [],
          fill: false,
          label: 'Total',
          pointRadius: 0,
          spanGaps: false,
          yAxisID: 'total',
        }, {
          backgroundColor: colors[0],
          borderColor: colors[0],
          borderWidth: 0,
          data: this.data ? this.data[1]: [],
          fill: true,
          label: 'Used',
          pointRadius: 0,
          spanGaps: false,
          yAxisID: 'usage',
        }]
        if (this.data && this.data.length > 2) {
          datasets.push({
            backgroundColor: colors[1],
            borderColor: colors[1],
            borderWidth: 0,
            data: this.data ? this.data[2]: [],
            fill: true,
            label: 'Buffered',
            pointRadius: 0,
            spanGaps: false,
            yAxisID: 'usage',
          }, {
            backgroundColor: colors[2],
            borderColor: colors[2],
            borderWidth: 0,
            data: this.data ? this.data[3]: [],
            fill: true,
            label: 'Cached',
            pointRadius: 0,
            spanGaps: false,
            yAxisID: 'usage',
          })
        }
        return {datasets}
      },
      computedOptions() {
        return merge(this.options, {
          scales: {
            yAxes: [{
              id: 'usage',
              stacked: true,
              ticks: {
                min: 0,
                suggestedMax: this.maxValue,
                maxTicksLimit: 10,
                stepSize: 1024 * 1024,
                callback(value) {
                  return utils.prettyBytes(value);
                },
              },
            }, {
              id: 'total',
              display: false,
              ticks: {
                min: 0,
                suggestedMax: this.maxValue,
                maxTicksLimit: 10,
                stepSize: 1024 * 1024,
                callback(value) {
                  return utils.prettyBytes(value);
                },
              },
            }],
          },
          tooltips: {
            callbacks: {
              label(tooltipItem, data) {
                const prefix = data.datasets[tooltipItem.datasetIndex].label
                const value = +data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].y
                const total = +data.datasets[0].data[tooltipItem.index].y
                const prettyValue = utils.prettyBytes(value)
                const percent = Math.round(100 * value / total)
                if (tooltipItem.datasetIndex === 0) {
                  return undefined
                }
                return `${prefix}: ${prettyValue} (${percent}%)`
              },
              footer(tooltipItems, data) {
                const total = +data.datasets[0].data[tooltipItems[0].index].y
                const prettyTotal = utils.prettyBytes(total)
                return `Total: ${prettyTotal}`
              }
            }
          },
        })
      },
    },
  }
</script>
